import { render, staticRenderFns } from "./EditFormComponent.vue?vue&type=template&id=458e852e&scoped=true&"
import script from "./EditFormComponent.vue?vue&type=script&lang=js&"
export * from "./EditFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditFormComponent.vue?vue&type=style&index=0&id=458e852e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e852e",
  null
  
)

export default component.exports